import { Text } from '@kanda-libs/ks-design-library';
import StepIndicatorExpansions from './Expansions';
import StepDisplay from './StepDisplay';
import { FormattedStep } from './useStepIndicator';
import useStepIndicatorStep from './useStepIndicatorStep';

export interface StepIndicatorStepProps {
  step: FormattedStep;
  isLoading: boolean;
  first?: boolean;
  last?: boolean;
}

const StepIndicatorStep: React.FunctionComponent<StepIndicatorStepProps> =
  function ({ step, isLoading, first = false, last = false }) {
    const { classNames, hasExpansions, showExpand } =
      useStepIndicatorStep(step);
    return (
      <div className="flex flex-col text-14-22-em">
        {!first && (
          <div className="w-8 min-w-8  h-[22px] min-h-[22px] bg-neutral-300 -mb-4" />
        )}
        <div className="flex flex-row gap-x-4">
          <div className="flex w-8 min-w-8 h-8 min-h-8 rounded-full bg-neutral-300 z-20">
            <div className={classNames.circle}>
              <StepDisplay
                number={step.number}
                isPassed={step.isPassed}
                isLoading={isLoading}
              />
            </div>
          </div>
          <div className="my-auto">
            <Text
              className="text-neutral-900"
              isLoading={isLoading}
              text={step.text}
              skeletonProps={{
                width: '100px',
              }}
            />
          </div>
        </div>
        {!last && (
          <div className="w-8 min-w-8 h-[22px] min-h-[22px] bg-neutral-300 -mt-4" />
        )}
        {hasExpansions && step.expansions && (
          <StepIndicatorExpansions
            expansions={step.expansions}
            active={showExpand}
            isLoading={isLoading}
          />
        )}
      </div>
    );
  };

export default StepIndicatorStep;
